import { SegmentationIds } from 'constants/segmentation';
import { isDogProfile, PetProfile } from 'types/pet-profile';
import { omitNullableHandler } from 'utils/type-helper';

const baseKeysToOmit = [
  'selectedAllergies',
  'lastTouched',
  'id',
  'name',
  'updatedAt',
] as const;

const dogKeysToOmit = [...baseKeysToOmit, 'selectedWeight'] as const;

const catKeysToOmit = [
  ...baseKeysToOmit,
  'selectedWetFoodTypes',
  'selectedTastePreferences',
] as const;

/**
 * Check if petProfile has enough properties for API
 */
export default function getPetProfileArray({
  petProfile,
}: {
  petProfile?: PetProfile;
}): Array<SegmentationIds> {
  if (!petProfile) {
    return [];
  }

  const keysToOmit = isDogProfile(petProfile) ? dogKeysToOmit : catKeysToOmit;

  return Object.entries(petProfile)
    .map(([key, value]) => {
      if (!keysToOmit.includes(key as any)) {
        return value;
      }
    })
    .filter((v) => typeof v !== 'boolean')
    .flat()
    .filter(omitNullableHandler);
}
